import React from "react";
import "./AjeetMiniKeyFeatures.css";

const leftFeatures = [
  "Proprietary DISHA software for precise control.",
  "60% Indigenous Design and Manufacturing.",
  "Dynamic flight planning and waypoint navigation.",
  "GNSS compatibility (GPS, GLONASS, QZSS, GAGAN) for up to 36 satellites.",
];

const rightFeatures = [
  "Safety measures: Auto Disarm and Return to Home (RTH) upon signal loss or low battery.",
  "Communication Link capabilities: Transmit control commands from GCS to UAV & Transmit telemetry data from UAV to GCS.",
  
];

const AjeetMiniKeyFeatures = () => {
  return (
    <section className="zuppa_ajeet_key_wrapper py-5">
      <div className="container">
        <h2 className="zuppa_ajeet_key_heading text-center mb-5">
          Key Features
        </h2>

        <div className="row justify-content-center">
          {/* Left Column */}
          <div className="col-lg-6 col-md-12 mb-4">
            <ul className="zuppa_ajeet_key_list">
              {leftFeatures.map((feature, index) => (
                <li key={index} className="zuppa_ajeet_key_item">
                  <span className="zuppa_ajeet_key_bullet"></span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-md-12">
            <ul className="zuppa_ajeet_key_list">
              {rightFeatures.map((feature, index) => (
                <li key={index} className="zuppa_ajeet_key_item">
                  <span className="zuppa_ajeet_key_bullet"></span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AjeetMiniKeyFeatures;
